var _rect, _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgLoginNaver(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 57,
    viewBox: "0 0 56 57",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.755859,
    width: 55,
    height: 55,
    rx: 27.5,
    fill: "#03C75A",
    stroke: "#03C75A"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.1095 28.8392L24.6012 19.5059H19.25V37.0059H24.8905V27.6725L31.3988 37.0059H36.75V19.5059H31.1095V28.8392Z",
    fill: "white"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoginNaver);
export default __webpack_public_path__ + "static/media/login_naver.a0bdd96b54075bbcd509ff569c65648d.svg";
export { ForwardRef as ReactComponent };